import React, { PureComponent } from 'react';
import 'react-quill/dist/quill.snow.css';
import FiuLogo from '../../../../assets/images/FIU_footer.png';

class Footer extends PureComponent {

  render() {
    const {
      content = [],
    } = this.props;
    
    return (
      <div className="footer-wrapper">
        <div className="wrapper">
          <div className="text-footer-wrapper">
            <img src={FiuLogo} style={{ width: '90%', maxWidth: '350px', marginBottom: '10px' }} alt="" />
            <div className="social-icons-wrapper" style={{ display: 'flex', justifyContent: 'center' }}>
              {
                content.social_networks && content.social_networks.map((item, index) => (
                  <div className="social-icon-wrapper" key={`social-${index}-network`}>
                    <a
                      target="_blank"
                      href={item.url}
                      rel="noopener noreferrer"
                    >
                      <img className="icon-footer" src={item.icon} alt="social network" />
                    </a>
                  </div>
                ))
              }
            </div>
            <div className="text-footer ql-editor">
              {!content.hidden && <div className="rich-text-container" dangerouslySetInnerHTML={{__html: content.disclaimer_text }} />  /* backend sanitize :)*/ }
              
            </div>
          </div>
          <div className="icons-wrapper">
            <img src={FiuLogo} style={{ width: '100%' }} alt="" />
            <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '15px' }}>
              {
                content.social_networks && content.social_networks.map((item, index) => (
                  <div className="icon-wrapper" key={`social-${index}-network`}>
                    <a
                      target="_blank"
                      href={item.url}
                      rel="noopener noreferrer"
                    >
                      <img className="icon-footer" src={item.icon} alt="social network" />
                    </a>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/app/screens/landing/footer/index.js